import styles from '@components/components/Navigation/components/MetaHeader/components/MetaHeaderDesktop/MetaHeaderDesktop.module.scss';
import React from 'react';
import classNames from 'classnames';
import { FontAwesomeProIcon, Link } from '@wienenergiegithub/ui-next';

const AreaSwitch = ({ metaHeaderItems }) => (
  <nav
    aria-label="Bereiche"
    className={styles.menuItemWrapper}
    data-purpose="meta-switch"
  >
    <ul className={styles.menuList}>
      {metaHeaderItems?.map(({ id, isActive, title, url }) => (
        <li key={id}>
          <Link
            aria-current={isActive ? 'page' : 'false'}
            className={classNames(styles.menuItem, {
              [styles.active]: isActive,
            })}
            to={url}
          >
            {title}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

const MetaHeaderDesktop = ({ languageSwitch, metaMenu, rootLevel }) => {
  const { isEnglishPage, link: languageLink } = languageSwitch;

  return (
    <div className={styles.container}>
      <div className={styles.meta}>
        {metaMenu.length > 0 && <AreaSwitch metaHeaderItems={metaMenu} />}
        <nav aria-label="Sprache und Portal">
          <ul className={styles.metaLinkList}>
            {!!languageLink && (
              <li>
                <a
                  aria-label={
                    isEnglishPage
                      ? 'Sprache auf Deutsch ändern'
                      : 'Switch to English'
                  }
                  className={styles.menuItem}
                  href={languageLink.url}
                  target={languageLink.target ?? '_self'}
                >
                  {languageLink.title}
                </a>
              </li>
            )}
            {!!rootLevel?.service && (
              <li>
                <a
                  aria-label="Login"
                  className={styles.menuItem}
                  href={rootLevel.service}
                  id="my-account"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <FontAwesomeProIcon
                    className={styles.icon}
                    icon="user"
                    role="presentation"
                    type="regular"
                  />
                  <span className={styles.loginText}>Login</span>
                </a>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default MetaHeaderDesktop;
